import { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Chapter } from "./Chapter";

const ease = [0.22, 1, 0.36, 1];

export const Timeline = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 75%", "end 70%"] });

  return (
    <section id="journey" data-testid="timeline-section" className="py-24 md:py-32 px-6 lg:px-10 max-w-7xl mx-auto">
      <Chapter number="02" overline={t.chapters.journey.overline} title={t.chapters.journey.title} />

      <div ref={ref} className="relative pl-8 md:pl-16">
        <div className="absolute left-0 md:left-4 top-0 bottom-0 w-px bg-line" />
        <motion.div
          style={{ scaleY: scrollYProgress }}
          className="absolute left-0 md:left-4 top-0 bottom-0 w-px bg-volt origin-top"
        />

        <div className="space-y-16 md:space-y-24">
          {[...t.timeline].reverse().map((item, i) => (
            <motion.div
              key={item.years}
              data-testid={`timeline-item-${i}`}
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, ease }}
              className="relative group"
            >
              <span className={`absolute -left-8 md:-left-16 top-2 w-3 h-3 -translate-x-1/2 ml-0 md:ml-4 ${item.current ? "bg-volt" : "bg-line group-hover:bg-volt"} transition-colors`} style={{ left: undefined }} />
              <div className="flex flex-col md:flex-row md:items-baseline gap-2 md:gap-10">
                <span className={`font-mono text-sm md:text-base tracking-widest shrink-0 md:w-44 ${item.current ? "text-volt" : "text-dim"}`}>
                  {item.years}
                </span>
                <div className="border-l-0 md:border-l border-line md:pl-10 max-w-2xl">
                  <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-dim mb-2">{item.tag}</p>
                  <h3 className="font-heading font-bold text-xl md:text-2xl tracking-tight text-paper group-hover:text-volt transition-colors">
                    {item.title}
                  </h3>
                  <p className="font-mono text-xs text-dim mt-1 tracking-wide">{item.org}</p>
                  <p className="font-body text-sm md:text-base text-dim mt-4 leading-relaxed">{item.text}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
